// extracted by mini-css-extract-plugin
export default {"container":"copy-code_container","popover":"copy-code_popover","easeOut":"copy-code_easeOut"};